module.exports = __webpack_public_path__ + "img/icon_tap_06.a3d778c7.svg";